import React, { useEffect, useState } from 'react';
import { fetchOrgSettingsRequest, updateOrgSettingsRequest } from '../../../api/organizations/orgSlice';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Divider,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const ConsolidationPeriodSection = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const { settings } = useSelector((state) => state.org);

  const [consolidationPeriod, setConsolidationPeriod] = useState(settings?.consolidation_period || 0);

  useEffect(() => {
    dispatch(fetchOrgSettingsRequest());
  }, [dispatch]);

  useEffect(() => {
    if (settings) {
      setConsolidationPeriod(settings?.consolidation_period || 0);
    }
  }, [settings]);

  const handleSubmit = (updatedConsolidationPeriod) => {
    dispatch(updateOrgSettingsRequest({ updates: updatedConsolidationPeriod }));
  };

  const handleChange = (event) => {
    setConsolidationPeriod(event.target.value);
    handleSubmit({ consolidation_period: event.target.value });
  };

  return (
    <>
      <Paper elevation={0} sx={{ pl: '1rem', pt: '1rem' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="h6" sx={{ my: '1.5rem' }}>
            Consolidation Period
          </Typography>

          <Tooltip title="Configure how your e-invoice documents are consolidated for processing">
            <IconButton size="small">
              <InfoOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
        <Divider sx={{ mt: -2, mb: '1.5rem' }} />

        <Box display="flex" alignItems="center" gap={2}>
          <Typography variant="body1">Consolidation look-up period (Days)</Typography>
          <Tooltip
            sx={{ fontSize: '18px' }}
            title={
              <>
                <b>Daily Consolidation:</b>
                Choose the number of days (between 1-6) to process document daily morning at 00:00:00. Documents with
                Invoice Date older than the specified days will be consolidated and pushed to IRBM.
                <br />
                <br />
                <b>Monthly Consolidation:</b>
                Select Monthly Consolidation to consolidate all staged documents from the previous calendar month
                between 1st and 7th of every month.
              </>
            }
            slotProps={{
              tooltip: {
                sx: {
                  fontSize: '14px',
                  maxWidth: 500,
                },
              },
            }}
          >
            <IconButton size="small">
              <InfoOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <FormControl sx={{ minWidth: 200 }}>
            <InputLabel>Consolidation Period</InputLabel>
            <Select value={consolidationPeriod} label="Consolidation Period" onChange={handleChange}>
              <MenuItem value={0}>Monthly Consolidation</MenuItem>
              <MenuItem value={1}>1</MenuItem>
              <MenuItem value={2}>2</MenuItem>
              <MenuItem value={3}>3</MenuItem>
              <MenuItem value={4}>4</MenuItem>
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={6}>6</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Paper>
    </>
  );
};

export default ConsolidationPeriodSection;
